// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const CartLg = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M8 18.5C8 17.6716 8.67158 17 9.5 17C10.3284 17 11 17.6716 11 18.5C11 19.3284 10.3284 20 9.5 20C8.67158 20 8 19.3284 8 18.5Z" fill={color} />
        <path d="M16 18.5C16 17.6716 16.6716 17 17.5 17C18.3284 17 19 17.6716 19 18.5C19 19.3284 18.3284 20 17.5 20C16.6716 20 16 19.3284 16 18.5Z" fill={color} />
        <path d="M3 5H4.55679C4.84054 5 5.09412 5.17457 5.1918 5.43717L8.09848 13.2513C8.48919 14.3017 9.50349 15 10.6385 15H16.6062C17.7706 15 18.8045 14.2655 19.1728 13.1767L20.9647 7.87748C21.1108 7.4458 20.7848 7 20.3231 7H10.1016" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);
